import { motion } from "framer-motion";
import { Award, MapPin, Users, Star } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const TrustBar = () => {
  const { language } = useLanguage();

  const stats = [
    {
      icon: Award,
      value: "35+",
      label: language === "fr" ? "Années d'Expérience RN" : "Years RN Experience"
    },
    {
      icon: MapPin,
      value: "3",
      label: language === "fr" ? "Cliniques" : "Clinic Locations"
    },
    {
      icon: Users,
      value: "10,000+",
      label: language === "fr" ? "Clients Traités" : "Clients Treated"
    },
    {
      icon: Star,
      value: "105",
      label: language === "fr" ? "Avis 5 Étoiles" : "Five-Star Reviews"
    }
  ];

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.3 }}
      className="bg-zinc-900/95 backdrop-blur-sm border-y border-zinc-800"
      data-testid="trust-bar"
    >
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.4 + index * 0.1 }}
              className="flex items-center justify-center gap-3 text-center md:text-left"
            >
              <div className="hidden sm:flex w-10 h-10 rounded-full bg-primary/20 items-center justify-center flex-shrink-0">
                <stat.icon className="w-5 h-5 text-primary" />
              </div>
              <div>
                <p className="text-xl md:text-2xl font-bold text-white">{stat.value}</p>
                <p className="text-xs md:text-sm text-zinc-400">{stat.label}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default TrustBar;
